import React from 'react';
import { Phone, Lock, Clock } from 'lucide-react';

const KanbanCard = ({ task, onEdit, onDragStart, onDragOver, onDrop }) => {
  const statusColors = {
    green: '#4ade80',
    red: '#f87171',
    yellow: '#fbbf24',
    blue: '#60a5fa',
    gray: '#6b7280',
  };

  const handleDragStart = (e) => {
    onDragStart(task);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDragOver(e, task);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDrop(task.status, task);
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      className="bg-card-dark rounded-lg p-3 mb-3 border border-card-border hover:border-card-border-hover transition-all cursor-move group min-h-[140px]"
      onClick={(e) => {
        onEdit(task);
      }}
    >
      {/* Header: Opérateur et N° Contrat sur une seule ligne */}
      <div className="flex items-center justify-between mb-2">
        <div className="text-card-text font-bold text-base">{task.title}</div>
        <div className="text-card-muted text-xs font-medium">{task.contractNumber}</div>
      </div>

      {/* Agent - plus compact */}
      {task.agent && (
        <div className="flex items-center gap-1.5 mb-2">
          <div className="w-5 h-5 bg-column rounded flex items-center justify-center text-xs text-card-text font-medium">
            {task.agent.charAt(0)}
          </div>
          <span className="text-card-text text-xs font-medium">{task.agent}</span>
        </div>
      )}

      {/* Client et Contact - sur 2 lignes, plus compact */}
      <div className="space-y-1 mb-2">
        {task.clientName && (
          <div className="flex items-center gap-1.5">
            <span className="text-card-muted text-xs">👤</span>
            <span className="text-card-text text-xs">{task.clientName}</span>
          </div>
        )}
        {task.contactName && (
          <div className="flex items-center gap-1.5">
            <span className="text-card-muted text-xs">🎧</span>
            <span className="text-card-text text-xs">{task.contactName}</span>
          </div>
        )}
      </div>

      {/* Horaires et Actions sur une seule ligne */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 text-card-muted text-xs">
          <Clock className="w-3 h-3" />
          <span>{task.startTime} • {task.endTime}</span>
        </div>
        <div className="flex items-center gap-1">
          {task.hasCall && (
            <button className="p-1 hover:bg-column rounded transition-colors" onClick={(e) => e.stopPropagation()}>
              <Phone className="w-3.5 h-3.5 text-card-muted" />
            </button>
          )}
          {task.isLocked && (
            <button className="p-1 hover:bg-column rounded transition-colors" onClick={(e) => e.stopPropagation()}>
              <Lock className="w-3.5 h-3.5 text-card-muted" />
            </button>
          )}
        </div>
      </div>

      {/* Status du contrat - UNIQUEMENT pour CONTRE VISITE avec commentaire de refus */}
      {task.status === 'contrevisite' && task.contractReason && (
        <div
          className="rounded-md p-2 bg-red-500/10"
          style={{
            borderLeft: `3px solid #ef4444`,
          }}
        >
          <div className="text-red-500 font-semibold text-xs mb-0.5">
            {task.contractStatus || 'REFUS'}
          </div>
          <div className="text-card-text text-xs leading-tight">
            {task.contractReason}
          </div>
        </div>
      )}
    </div>
  );
};

export default KanbanCard;
